import React, { useMemo } from 'react'
import { Button, Space } from 'antd'
import { isEmpty, isNil } from 'lodash'
import PropTypes from 'prop-types'

import { PermissionGuard } from '../../../account/components/sections'

const FormButtons = ({
  permissions,
  onReset,
  onSave,
  saveText,
  isDisabled,
  isLoading,
}) => {
  const buttons = useMemo(
    () => (
      <Space>
        <Button htmlType="button" ghost danger onClick={onReset}>
          Cancel
        </Button>

        <Button
          type="primary"
          onClick={onSave}
          htmlType={isNil(onSave) ? 'submit' : undefined}
          loading={isLoading}
        >
          {saveText}
        </Button>
      </Space>
    ),
    [isLoading, onReset, onSave, saveText],
  )

  if (isDisabled) {
    return null
  }

  return isEmpty(permissions) ? (
    buttons
  ) : (
    <PermissionGuard permissions={permissions}>{buttons}</PermissionGuard>
  )
}

FormButtons.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string),
  onReset: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onSave: PropTypes.func,
  saveText: PropTypes.string,
}

FormButtons.defaultProps = {
  permissions: [],
  isDisabled: false,
  onSave: undefined,
  saveText: 'Save',
  isLoading: false,
}

export default FormButtons
